import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import * as f from "../../utils/formatter";
import { identity } from "shared/src/util.mjs";

export default function DoctorIcon({ availableEmployees, selectedDoctors }) {
  const filterInterestingDoctors = React.useMemo(() => {
    if (selectedDoctors.any) {
      return identity;
    }

    if (selectedDoctors.doctors.length === 0) {
      return () => [];
    }

    const ids = new Set(selectedDoctors.doctors.map((d) => d.id));

    return function (availableDoctors) {
      return availableDoctors.filter((d) => ids.has(d.id));
    };
  }, [selectedDoctors]);

  const employees = filterInterestingDoctors(availableEmployees);

  if (employees.length === 0) {
    return;
  }

  const title = employees.map((e) => f.fullName(e)).join(", ");

  return (
    <Tooltip title={title}>
      <FontAwesomeIcon
        style={{
          color: "var(--mui-palette-info-indicator)",
        }}
        icon={faUserDoctor}
      />
    </Tooltip>
  );
}
